export function dataToLocalTime(prevDate: any) {
  const date = new Date(
    prevDate?.seconds * 1000 + prevDate?.nanoseconds / 1000000
  );
  const dateInLocalTime = new Date(date.getTime());
  const formattedDate = dateInLocalTime?.toLocaleString();
  return formattedDate || undefined;
}
